import {
  ChangeDetectionStrategy,
  Component,
  computed,
  inject,
  input,
  signal,
} from '@angular/core';
import {CommonModule} from '@angular/common';
import {UmpireComponentNews} from '@tisa-group/models';
import {CarouselModule} from '@tisa-group/client-ui/components/carousel';
import {RelativeTimeFormatPipe} from '@tisa-group/client-ui/pipes/relative-time-format';
import {SvgIconComponent} from '@tisa-group/client-ui/components/svg-icon';
import {RouterLink} from '@angular/router';
import {TISA_CURRENT_LOCALE} from '@tisa-group/client-ui/tokens';

@Component({
  selector: 'tisa-news',
  imports: [
    CommonModule,
    CarouselModule,
    SvgIconComponent,
    RelativeTimeFormatPipe,
    RouterLink,
  ],
  templateUrl: './news.component.html',
  styleUrl: './news.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NewsComponent {
  readonly locale = inject(TISA_CURRENT_LOCALE);

  readonly component = input<UmpireComponentNews | undefined>();

  readonly articles = computed(() => this.component()?.articles || []);

  buttonRightDisabled = signal(false);

  buttonLeftDisabled = signal(true);

  onButtonRightStatusChanges(disabled: boolean) {
    this.buttonRightDisabled.set(disabled);
  }

  onButtonLeftStatusChanges(disabled: boolean) {
    this.buttonLeftDisabled.set(disabled);
  }
}
